"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEyeSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 3c3.602 0 6.664 1.333 8.978 3.563C22.79 8.309 24 10.547 24 11.936c0 1.389-1.21 3.627-3.022 5.373-2.314 2.23-5.376 3.563-8.978 3.563-3.6 0-6.663-1.333-8.978-3.563C1.286 15.636.102 13.51.006 12.114L0 11.936l.006-.178c.096-1.396 1.28-3.522 3.017-5.195C5.337 4.333 8.399 3 12 3zm0 4.085a4.851 4.851 0 100 9.703 4.851 4.851 0 000-9.703zm0 1.532a3.32 3.32 0 110 6.639 3.32 3.32 0 010-6.639z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEyeSolid;
exports.default = _default;